module.exports = __webpack_public_path__ + "img/0Q3B3739_Wood_MockedUp.05df075c.jpg";